import { MarblesGlossary } from './marbles-glossary';
export const ValueLiteral = {};

export const NotificationKindChars = {
  N: ValueLiteral,
  C: MarblesGlossary.Completion,
  E: MarblesGlossary.Error,
};
